import React from 'react';

import { Main } from '@/components';
import {
  Logo,
  Apple,
  Google,
  Huawei,
  YouTube,
  VK,
  OkSocial,
  Messenger,
  Viber,
  Telegram,
  WhatUp
} from '@/icons';

import styles from './footer.module.scss';

const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <Main>
      <div className={styles.footer__line}>
        <div className={styles.footer__line}>
          <a
            className={styles.footer__logoLink}
            href='https://novosibirsk.fitauto.ru/'
            target='_blank'
            rel='noreferrer'
          >
            <Logo className={styles.footer__logo} />
          </a>
          <div className={styles.footer__column}>
            <a
              href='https://apps.apple.com/ru/app/%D0%B0%D0%B2%D1%82%D0%BE%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81-fit-service/id1641712820?utm_source=lending&utm_medium=poluchit_dostup'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__storeLink}
            >
              <Apple />
              <span className={styles.footer__store}>Доступно в App Store</span>
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.garpix.fitapp&hl=en_US?utm_source=lending&utm_medium=poluchit_dostup'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__storeLink}
            >
              <Google />
              <span className={styles.footer__store}>
                Доступно в Google play
              </span>
            </a>
            <a
              href='https://appgallery.huawei.com/app/C109853151?utm_source=lending&utm_medium=poluchit_dostup'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__storeLink}
            >
              <Huawei />
              <span className={styles.footer__store}>
                Доступно в AppGallery
              </span>
            </a>
          </div>
        </div>
        <div className={styles.footer__column}>
          <a href='tel:88007007306' className={styles.footer__tel}>
            8(800)700-73-06
          </a>
          <a href='mailto:fit.fleet@fitauto.ru' className={styles.footer__mail}>
            fit.fleet@fitauto.ru
          </a>
          <div className={styles.footer__social}>
            <a
              href='https://www.youtube.com/channel/UCH_tSjkwIYaGJW4lGkZOuIA'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <YouTube />
            </a>
            <a
              href='https://vk.com/fit_service'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <VK />
            </a>
            <a
              href='https://ok.ru/group/54078179442879'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <OkSocial />
            </a>
            <a
              href='https://t.me/fitservice_official'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <Messenger />
            </a>
          </div>
          <div className={styles.footer__social}>
            <a
              href='https://chats.viber.com/fitservice/ru'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <Viber />
            </a>
            <a
              href='https://telegram.im/@FiTServiceK_bot'
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <Telegram />
            </a>
            <a
              href=' https://api.whatsapp.com/send?phone=79059458308&text=%d0%94%d0%be%d0%b1%d1%80%d1%8b%d0%b9%20%d0%b4%d0%b5%d0%bd%d1%8c%21%20%d0%9c%d0%b5%d0%bd%d1%8f%20%d0%b8%d0%bd%d1%82%d0%b5%d1%80%d0%b5%d1%81%d1%83%d0%b5%d1%82&source=&data=&app_absent='
              target='_blank'
              rel='noreferrer'
              className={styles.footer__socialItem}
            >
              <WhatUp />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footer__line}>
        <a
          className={styles.footer__link}
          href='https://novosibirsk.fitauto.ru/new/assets/files/politika-konfidencialnosti-ooo.pdf'
          target='_blank'
          rel='noreferrer'
        >
          Политика обработки персональных данных
        </a>
        <p className={styles.footer__text}>
          {`2010—${new Date().getFullYear()} © ООО «ФИТ Автосервис»`}
        </p>
      </div>
    </Main>
  </footer>
);

export default Footer;
